import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_URL, ENDPOINTS } from '../../constants/api';
import { getToken } from '../../utils/TokenUtils';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { darcula } from 'react-syntax-highlighter/dist/esm/styles/prism'; // or any other theme

const SqlViewer = () => {
  const [content, setContent] = useState('');
  const [error, setError] = useState('');
  const token = getToken();
  useEffect(() => {
    const fetchSql = async () => {
      try {
        const response = await axios.get(
          `${API_URL}/${ENDPOINTS.SYS}/sql-updates`,
          {
            headers: {
              Authorization: token ? `Bearer ${token}` : '',
            },
          }
        );
        setContent(response.data.content); // assumes { content: '...' }
      } catch (err) {
        setError('Failed to load SQL file.');
      }
    };

    fetchSql();
  }, []);

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial' }}>
      <h2>SQL File Content</h2>
      {error ? (
        <p style={{ color: 'red' }}>{error}</p>
      ) : (
        <SyntaxHighlighter
          language="sql"
          style={darcula}
          showLineNumbers
          wrapLongLines
          customStyle={{
            maxHeight: '75vh',
            borderRadius: '8px',
            padding: '20px',
          }}
        >
          {content}
        </SyntaxHighlighter>
      )}
    </div>
  );
};

export default SqlViewer;
